// extracted by mini-css-extract-plugin
export default {"title":"PaneTitle-module__title__2Asvi","icon":"PaneTitle-module__icon__Y6QWc"};